<template>
  <van-popup v-model="showAgreement" :style="{width: '80%', height: '80%',background: '#fff', borderRadius: '12px', padding: '20px 16px'}">
    <div class="popup-box">
      <h2 class="title">卡友须知</h2>
<!--      <div class="text">忍者搬运”为北京豆芽科技有限公司所属的业务-->
<!--        板块，主要为客户提供搬运、运输、收纳整理等服-->
<!--        务；为物流车队、车主、司机提供搬家、货运等订-->
<!--        单业务，是一个双向交易的网络货运撮合平台。</div>-->
      <div class="sub-title">一、约定事项</div>
      <div class="text">忍者搬运受江淮轻卡委托，为江淮轻卡指定车主派发搬家业务的货源订单，并对服务全程【从接单到收款】跟进。</div>
<!--      <div class="text">2. 意向购买忍者搬运合约包订单用户：凡江淮轻卡车主均可通过江淮卡友APP购买忍者搬运货源包。购买咨询电话：4008009933</div>-->
      <div class="sub-title">二、要求</div>
      <div class="text">1、车辆要求：拥有一台江淮轻卡（箱式或平板，厢长3.8米或4.2米）。</div>
      <!--      <div class="text">忍者搬运”为北京豆芽科技有限公司所属的业务-->
      <!--        板块，主要为客户提供搬运、运输、收纳整理等服-->
      <!--        务；为物流车队、车主、司机提供搬家、货运等订-->
      <!--        单业务，是一个双向交易的网络货运撮合平台。</div>-->
      <div class="sub-title">一、约定事项</div>
      <div class="text">忍者搬运受江淮轻卡委托，为江淮轻卡指定车主派发搬家业务的货源订单，并对服务全程【从接单到收款】跟进。</div>
      <!--      <div class="text">2. 意向购买忍者搬运合约包订单用户：凡江淮轻卡车主均可通过江淮卡友APP购买忍者搬运货源包。购买咨询电话：4008009933</div>-->
      <div class="sub-title">二、要求</div>
      <div class="text">1、车辆要求：拥有一台江淮轻卡（箱式或平板，车长3.8米—4.2米）。</div>
      <div class="text">2、技能要求：具备搬运、搬家相关业务的技能，如：拆装、打包、搬运能力；有长期合作的搬运工，能根据订单配备相应的服务人员（如小家庭型搬家单次搬运需至少配备2名搬运师傅）。忍者搬运平台方（以下简称平台方）会判定接单用户是否具备搬家、货运服务能力，如判定该用户无服务能力，有权拒绝该用户承接订单。</div>
      <div class="text">3、人员要求：若司机进行搬运，则至少还需要1名搬运工；若司机不进行搬运，则至少还需要2名搬运工。</div>
      <div class="sub-title">三、违约责任：</div>
      <div class="text">1、违约责任：</div>
      <div class="text">司机方有下列行为之一，平台方有权单方面解除双方协议，并追究司机方相应责任；</div>
      <div class="text">1）司机方在合作期间触犯国家法律、法规、治安条例及被劳教或判刑的。</div>
      <div class="text">2）司机方违规经营，受到新闻媒体曝光批评，工商处罚等，造成负面影响的。</div>
      <div class="text">3）司机方不服从平台方的管理、处罚等，情节恶劣的。</div>
      <div class="text">4）司机方为平台方客户服务产生严重投诉（打架，辱骂威胁客户，乱收费，偷盗，过失造成客户较大损失等）。</div>
      <div class="text">2、违规责任：</div>
      <div class="text">一旦由于司机原因出现跳单、违约、私下交易、辱骂客户、损坏货品等行为，均会对司机进行相应的处罚，包括但不限于以下行为：</div>
      <div class="text">1）与客户发生冲突：司机现场辱骂客户或与客户发生肢体冲突造成的订单流失，计为已消耗派单。</div>
      <div class="text">2）未如期提供服务：如因司机个人原因无法接单，须至少提前1天告知平台，便于平台有时间安排其他司机继续接单，如服务当天如因司机原因未能如期服务造成订单流失，计为已消耗派单。</div>
      <div class="text">3）服务爽约：司机接单后未提供服务或有特殊情况未提前半天做出申请，计为已消耗派单。</div>
      <div class="text">4）跳单：派发的订单如因客户原因取消，而司机未提供录音或其他可证明文件，计为已消耗派单；如客户主动取消订单后，经平台核实该客户仍被该司机所服务，计为已消耗派单且追究司机责任。</div>
      <div class="text">5）私自加价：如司机有私下加价行为，对平台造成极其不良的信用影响，平台有权对其追究法律责任。</div>
      <div class="sub-title">四、损坏与赔偿</div>
      <div class="text">1、如因司机在服务过程中由于操作不当造成的物品索赔，司机有义务与雇主进行协商赔付，如拒不赔付者，平台、雇主有权对其追究相应的责任。</div>
      <div class="text">2、如现场客户临时增加了贵重物品，司机有权要求对其进行包装，如因没有建议包装，发生破损，根据客户要求的索赔量进行相应赔付；贵重物品在已告知客户需要包装而客户仍未包装的前提下，司机仍坚持运输，由此造成的破损根据损坏物品的价值进行赔付。</div>
      <div class="sub-title">五、 服务计费约定</div>
      <div class="text">1、派单订单：以实际派单时，双方协商的分佣额为准。</div>
      <div class="text">2、线下产生的费用：平台需抽取加价部分的35%，剩余归司机所有。</div>
      <div class="text">3、支付劳动报酬：通过平台方企业微信号进行结算，订单完成3日内方可结算，遇到周末顺延至周一结算。</div>
      <div class="sub-title">六、其他约定</div>
      <div class="text">司机是自主的经营主体，独立经营、独立核算，司机因日常经营或运输服务过程中产生的任何风险及安全事故均由司机方自行承担，与江淮轻卡及忍者搬运平台方无关。</div>
      <van-button
        round block
        type="info"
        class="popup-btn"
        @click="showAgreement = false"
      >
        确定
      </van-button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'PopupBox',
  data() {
    return {
      showAgreement: false
    }
  },
  methods: {
    openPopup() {
      this.showAgreement = true
    },
    closePopup() {
      this.showAgreement = false
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-box {
  line-height: rem(38);
  color: #333;
  font-size: rem(26);
  .title {
    margin-bottom: rem(32);
    font-size: rem(32);
    font-weight: 700;
    text-align: center;
  }
  .sub-title {
    height: rem(40);
    padding: rem(24) 0 rem(16) 0;
    font-size: rem(28);
    font-weight: 700;
  }
  .popup-btn {
    margin-top: rem(56);
    color: #fff;
    font-size: rem(32);
    background: linear-gradient(90deg, #FF5D5D 0%, #D82626 100%);
    border: none;
  }
}
</style>
